import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import linkListStyles from "./LinksList.module.css";
import { Button } from "@commonwealthdevelopment/web-ui-component-library";
import { Body, Header } from "../../components";
import { useNavigate } from "react-router-dom";
import { Table } from "@commonwealthdevelopment/web-ui-component-library";
import { AiOutlineCaretDown, AiOutlineCaretUp } from "react-icons/ai";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { Link } from "react-router-dom";
import {
  allowedGroups,
  useAuthorization,
} from "../../contexts/AuthorizationContext";
import { Badge } from "reactstrap";

const defaultFormValues = {
  currentSort: {
    id: "CreatedAt",
    asc: false,
  },
  pageNumber: 0,
  pageCount: 0,
  showOnlyExpiredFilter: false,
  searchValue: "",
  type: "",
};

export const LinksList = ({ itemsPerPage }) => {
  const navigate = useNavigate();
  const { groups, selectedGroup, changeGroup } = useAuthorization();

  const [data, setData] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [formValues, setFormValues] = useState({
    ...defaultFormValues,
    type: selectedGroup,
  });
  const [pageCount, setPageCount] = useState(null);

  const { error, execute, isLoading } = useFetchWithMsal();

  useEffect(() => {
    execute(
      "GET",
      `AccessLinks/paged?pageNumber=${formValues.pageNumber}&pageSize=${itemsPerPage}&showOnlyExpired=${formValues.showOnlyExpiredFilter}&sortColumn=${formValues.currentSort.id}&isSortAsc=${formValues.currentSort.asc}&search=${formValues.searchValue}&type=${selectedGroup}`
    ).then((response) => {
      if (response) {
        setData(response.data);
        setPageCount(response.totalPages);
      }
    });
  }, [execute, itemsPerPage, formValues, selectedGroup]);

  const handlePageClick = (event) => {
    setFormValues((prev) => ({ ...prev, pageNumber: event.selected }));
  };

  const handleCheckBoxChange = (event) => {
    setFormValues((prev) => ({
      ...prev,
      showOnlyExpiredFilter: !prev.showOnlyExpiredFilter,
    }));
  };

  const handleCurrentSortChange = (columnId) => {
    setFormValues((prev) => ({
      ...prev,
      currentSort: {
        ...prev.currentSort,
        id: columnId,
        asc: prev.currentSort?.id === columnId ? !prev.currentSort?.asc : true,
      },
    }));
  };

  const handleTypeSelectorChange = (event) => {
    changeGroup(event.target.value);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setFormValues((prev) => ({ ...prev, searchValue: searchInput }));
  };

  return (
    <>
      <Header>
        <h1>Authentication Links List</h1>
      </Header>

      <>
        <Body>
          {selectedGroup === allowedGroups.PROSPECT.value && (
            <div className={linkListStyles.createLinkBtn}>
              <Button
                automationId="story_button"
                iconSize="2em"
                iconType="plus-circle"
                onClick={() => navigate("/links/new")}
                showIcon
              >
                Generate Authentication Link
              </Button>
            </div>
          )}

          {isLoading && !data ? (
            <h1>Loading...</h1>
          ) : (
            <>
              <div className={linkListStyles.actionsHeader}>
                <form onSubmit={handleSearch}>
                  <div className={linkListStyles.inputGroup}>
                    <label htmlFor="searchInput">Search: </label>
                    <input
                      type="text"
                      id="searchInput"
                      onChange={(e) => setSearchInput(e.target.value)}
                      value={searchInput}
                    />
                  </div>
                  {selectedGroup === allowedGroups.PROSPECT.value && (
                    <div className={linkListStyles.inputGroup}>
                      <label htmlFor="showExpRevokedCheckbox">
                        Show only Expired/Revoked
                      </label>

                      <input
                        type="checkbox"
                        id="showExpRevokedCheckbox"
                        checked={formValues.showOnlyExpiredFilter}
                        onChange={handleCheckBoxChange}
                        title="Show only Expired"
                        value={formValues.showOnlyExpiredFilter}
                      />
                    </div>
                  )}
                  {groups.length > 1 && (
                    <div className={linkListStyles.inputGroup}>
                      <label htmlFor="typeSelector">Type</label>
                      <select
                        id="typeSelector"
                        value={selectedGroup}
                        onChange={handleTypeSelectorChange}
                        style={{ width: "200px" }}
                      >
                        {groups.map((group) => (
                          <option key={group.value} value={group.value}>
                            {group.displayName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </form>
              </div>

              <div className={linkListStyles.tableTitle}>
                <p>
                  <small>
                    List of{" "}
                    <strong>{`${
                      formValues.showOnlyExpiredFilter ? "expired/deleted" : ""
                    }`}</strong>{" "}
                    {`authentication links created for `}{" "}
                    <strong>{`${
                      selectedGroup === allowedGroups.PROSPECT.value
                        ? "affiliates"
                        : "commlink accounts"
                    }`}</strong>
                    :
                  </small>
                </p>
              </div>

              <Table width="100%" className={linkListStyles.table}>
                <colgroup>
                  <col span="1" style={{ width: "20%" }}></col>
                  <col span="1" style={{ width: "auto" }}></col>
                  {selectedGroup === allowedGroups.PROSPECT.value && (
                    <col span="1" style={{ width: "auto" }}></col>
                  )}
                  <col span="1" style={{ width: "20%" }}></col>
                  {selectedGroup === allowedGroups.PROSPECT.value && (
                    <col span="1" style={{ width: "10%" }}></col>
                  )}
                  <col span="1" style={{ width: "120px" }}></col>
                  <col span="1" style={{ width: "100px" }}></col>
                </colgroup>
                <thead>
                  <tr>
                    <th onClick={() => handleCurrentSortChange("ExpireAt")}>
                      <div>
                        Expire Date
                        {formValues.currentSort.id === "ExpireAt" ? (
                          formValues.currentSort.asc ? (
                            <AiOutlineCaretUp />
                          ) : (
                            <AiOutlineCaretDown />
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    </th>
                    <th onClick={() => handleCurrentSortChange("ProspectName")}>
                      For
                    </th>
                    {selectedGroup === allowedGroups.PROSPECT.value && (
                      <th onClick={() => handleCurrentSortChange("Notes")}>
                        Notes
                      </th>
                    )}
                    <th onClick={() => handleCurrentSortChange("CreatedAt")}>
                      <div>
                        Create Date
                        {formValues.currentSort.id === "CreatedAt" ? (
                          formValues.currentSort.asc ? (
                            <AiOutlineCaretUp />
                          ) : (
                            <AiOutlineCaretDown />
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    </th>
                    {selectedGroup === allowedGroups.PROSPECT.value && (
                      <th onClick={() => handleCurrentSortChange("CreatedBy")}>
                        <div>
                          Created By
                          {formValues.currentSort.id === "CreatedBy" ? (
                            formValues.currentSort.asc ? (
                              <AiOutlineCaretUp />
                            ) : (
                              <AiOutlineCaretDown />
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      </th>
                    )}
                    <th onClick={() => handleCurrentSortChange("Status")}>
                      Status
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {data &&
                    data.map((d) => (
                      <tr key={d.id}>
                        <td>{d.expireAt}</td>
                        <td>{d.email || d.prospectName}</td>
                        {selectedGroup === allowedGroups.PROSPECT.value && (
                          <td>{d.notes}</td>
                        )}
                        <td>{d.createdAt}</td>
                        {selectedGroup === allowedGroups.PROSPECT.value && (
                          <td>{d.createdBy}</td>
                        )}
                        <td>
                          {d.status === "Active" ? (
                            d.wasAccessedBefore ? (
                              <Badge color="warning" pill>
                                Accessed
                              </Badge>
                            ) : (
                              <Badge color="success" pill>
                                {d.status}
                              </Badge>
                            )
                          ) : (
                            <Badge color="danger" pill>
                              {d.status}
                            </Badge>
                          )}
                        </td>
                        <td>
                          <Link to={`/links/${d.id}`}>Details</Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              <div className={linkListStyles.pagination}>
                <ReactPaginate
                  nextLabel=">"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={2}
                  pageCount={pageCount}
                  previousLabel="<"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName="active"
                  renderOnZeroPageCount={null}
                />
              </div>
            </>
          )}
        </Body>
      </>
    </>
  );
};
